import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Hero from '../components/Hero';
import About from '../components/About';
import VisionMission from '../components/VisionMission';
import Values from '../components/Values';
import Vision2030 from '../components/Vision2030';
import Stats from '../components/Stats';
import Diver from '../components/Diver';
import NationalResponsibility from '../components/NationalResponsibility';
import StrategicGoals from '../components/StrategicGoals';
import Partners from '../components/Partners';

const AboutPage = () => {
  const { theme } = useOutletContext();

  return (
    <>
      <Hero theme={theme} />
      <About />
      <VisionMission theme={theme} />
      <Vision2030 theme={theme} />
      <NationalResponsibility theme={theme} />
      <StrategicGoals theme={theme} />
      <Diver />
      <Values theme={theme} />
      <Stats />
      <Partners />
    </>
  );
};

export default AboutPage;
